<template>
  <protected-pages-layout>
  <div class="wrapper">
    <div
      v-if="!pageReady"
      class="d-flex justify-content-center align-items-center m-5"
    >
      <div
        class="spinner-border text-dark"
        style="width: 7.5rem; height: 7.5rem"
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else class="wrapper">
      <div class="container-fluid">
        <div class="row" style="margin: 30px 0">
          <div class="col-md-10 offset-md-1 align-center" style="width: 20%">
            <form>
              <div class="row">
                <div class="col">
                  <label for="periodSelect">Period</label>
                  <select
                    v-model="parametersTSOC.period"
                    class="form-select"
                    id="periodSelect"
                    @change="loadData()"
                  >
                    <option
                      :key="index"
                      :value="period.value"
                      v-for="(period, index) in periods"
                    >
                      {{ period.name }}
                    </option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-10 offset-md-1 align-center" style="width: 20%">
            <button
              class="btn btn-outline-primary mt-4"
              @click="exportTimeSpendOnClientToCSV(timeSpentOnClient)"
            >
              Download chart data
            </button>
          </div>
        </div>
      </div>
      <div class="container-fluid table-wrapper-tsoc" style="width: 100%;">
        <v-card flat class="card border-0 shadow">
          <v-col cols="12">
            <v-row>
              <v-col cols="12">
                <v-card-item class="sticky">
                  <v-card-title>Time Booked Per User</v-card-title>
                  <v-text-field
                    v-model="searchQuery"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    variant="outlined"
                    single-line
                    hide-details
                    class="mx-4"
                  >
                  </v-text-field>
                </v-card-item>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-card-text>
                <v-data-table-virtual
                  :headers="headers"
                  :items="timeSpentOnClient"
                  :search="searchQuery"
                  fixed-header=""
                  :loading="tableDataReady"
                  class="table-wrapper-tsoc"
                >
                  <template #bottom></template>
                </v-data-table-virtual>
              </v-card-text>
            </v-row>
          </v-col>
        </v-card>
      </div>
    </div>
  </div>
</protected-pages-layout>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { storeToRefs } from "pinia";
import { periods } from "../assets/variables";
import { useTeamMembersReportStore } from "../stores/teamMembersReport";
import _ from "lodash";

const teamMembersReportStore = useTeamMembersReportStore();
const { parametersTSOC, timeSpentOnClient } = storeToRefs(
  teamMembersReportStore,
);

const { getTimeSpendOnClient, exportTimeSpendOnClientToCSV } =
  teamMembersReportStore;

const pageReady = ref(false);
const tableDataReady = ref(true);
const searchQuery = ref("");
let timeout;
watch(searchQuery, (newQuery) => {
  clearTimeout(timeout);
  timeout = setTimeout(() => {}, 500);
});

const headers = [
  { title: "Name", key: "Name", align: "center", sortable: true },
  { title: "Role", key: "Role", align: "cnter", sortable: true },
  { title: "Country", key: "Country", align: "center", sortable: true },
  { title: "Pod", key: "Pod", align: "center", sortable: true },
  { title: "Total Logged", key: "SumAll", align: "center", sortable: true },
  {
    title: "Billable Hours",
    key: "SumBillable",
    align: "center",
    sortable: true,
  },
  {
    title: "Non Billable Hours",
    key: "SumNonBillable",
    align: "center",
    sortable: true,
  },
  {
    title: "Total Client Hours",
    key: "Client",
    align: "center",
    sortable: true,
  },
  {
    title: "Internal Hours",
    key: "SumInternal",
    align: "center",
    sortable: true,
  },
  {
    title: "Business Days",
    key: "NumberOfBusisnessDays",
    align: "center",
    sortable: true,
  },
  { title: "Days Off", key: "DaysOffDays", align: "center", sortable: true },
  {
    title: "Average Time spent on clients (week)",
    key: "Result",
    align: "center",
    sortable: true,
  },
];

onMounted(async () => {
  await getTimeSpendOnClient();
  pageReady.value = true;
  tableDataReady.value = false;
});

const loadData = async () => {
  tableDataReady.value = true;
  await getTimeSpendOnClient();
  tableDataReady.value = false;
};
</script>

<script>
import Navbar from "../components/Navbar.vue";
import ExportModule from "../components/ExportModule.vue";
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
export default defineComponent({
  name: "TimeBookedPerUser",
  components: {
    navbar: Navbar,
    ExportModule,
  },
});
</script>

<style lang="scss">
.wrapper {
  width: clamp(
    867px,
    calc(100vw * 0.8465),
    2166px
  );
  aspect-ratio: 1219/811;
  margin: 0 auto;
  display: flex; 
  flex-direction: column;
}

.table-wrapper-tsoc {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
}

.table-wrapper-tsoc .v-card-text,
.table-wrapper-tsoc .v-data-table-virtual {
  flex: 1;
  overflow-y: auto;
  min-width: 0;  /* critical so long columns wrap instead of forcing overflow */
}

.table-wrapper-tsoc .v-data-table-virtual__table {
  width: 100%;
  table-layout: fixed;
}

.table-wrapper-tsoc th,
.table-wrapper-tsoc td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-scroll {
  width: 100%;
  overflow-y: scroll;
  max-height: max-content;
}
</style>
